import {useSelector} from 'react-redux';

import {getBannerText} from 'state/selectors';

import styles from './Banner.module.scss';

export default function Banner() {
  const bannerData = useSelector(getBannerText);
  if (!bannerData || !bannerData.text?.trim() || !bannerData.startDate || !bannerData.endDate) {
    return null;
  }

  const now = new Date();
  const startTime = new Date(bannerData.startDate);
  const endTime = new Date(bannerData.endDate);

  const isWithinDateRange = now >= startTime && now <= endTime;

  if (!isWithinDateRange) {
    return null;
  }

  return (
    <div className={styles.Banner}>
      <i className="exclamation triangle icon yellow" />
      <span dangerouslySetInnerHTML={{__html: bannerData.text}} />
    </div>
  );
}
